import OvertimeDrivingAlarmModal from './overtime_driving_alarm-modal.vue'
export default OvertimeDrivingAlarmModal
